export const SURVEY = "SURVEY"
export const SHARED_SOLUTION = "SHARED_SOLUTION"

export const JWT_CLAIM_NAMESPACE = "https://classsolver.com"
export const MFA_CLAIM = `${JWT_CLAIM_NAMESPACE}/mfa`
export const CONNECTION_NAME_CLAIM = `${JWT_CLAIM_NAMESPACE}/connection_name`
export const CONNECTION_STRATEGY_CLAIM = `${JWT_CLAIM_NAMESPACE}/connection_strategy`
